export default __webpack_public_path__ + "static/media/github-redux.e4a4a65c.png";